export default __webpack_public_path__ + "static/media/darkmode-icon.800a993d.svg";